import {FiArrowUp} from "react-icons/fi";
import {PROFILE} from "../../data/resume";

export const Footer = () => (
    <footer className="site-footer shell">
        <div className="footer-top"><a className="wordmark" href="#top">{PROFILE.name}<span aria-hidden="true">.</span></a><p>Outside the editor: hiking, climbing, surfing, and exploring what’s next.</p><a className="text-link" href="#top">Back to top <FiArrowUp aria-hidden="true" /></a></div>
        <div className="footer-bottom"><p>© {new Date().getFullYear()} {PROFILE.name}</p><nav aria-label="Footer navigation"><a href="#projects">Work</a><a href="#experience">Experience</a><a href="#skills">Capabilities</a><a href="#resume">Résumé</a><a href="#contact">Contact</a></nav></div>
    </footer>
);
